export default {
  pigletTitle: 'Ferkel Einteilung',
  calendarWeek: 'KW',
  cooperationMode: 'KoV',
  cooperationModeLabel: {
    none: '-',
    shorted: 'K',
    exchange: 'V'
  },
  duplicateRegistration: 'Es wurde bereits für diesen Betrieb in der gewählten Woche gemeldet',
  driver: 'Fahrer',
  fattener: 'Mäster',
  fromFattening: 'Ab Hof',
  fromFatteningAndDelivery: 'Ab Hof/Zustellung',
  deliver: 'Zustellung',
  deadline: 'Meldezeitpunkt',
  registration: 'Meldung',
  register: "Melden",
  order: "Bestellen",
  orders: "Bestellungen",
  done: "Erledigt",
  day: 'Tag',
  time: 'Zeit',
  groups: "Meldegruppen",
  selectRegistrationDate: "Wählen Sie ein Meldedatum",
  count: 'Stk',
  countFromTransport: 'Stk Ein.',
  countSty: "Anzahl Mast",
  countBreed: "Anzahl Zucht",
  program: "Programm",
  comment: "Kommentar",
  selfDeliverd: "Selbstanlieferung",
  self: 'Selbst',
  bringForward: "Vorziehen",
  bringBackward: "Stehen gelassen",
  capacity: "Kapazitäten",
  restrict: 'Beschränken',
  history: 'Meldungshistorie',
  device: 'Gerät',
  dayFrom: 'Schlachttag',
  open: 'Offene Meldungen',
  week: 'Schlachtwoche',
  transport: 'Übernahme',
  transporter: 'LKW',
  transporterIndex: 'Fuhre',
  vaccination: 'Impfung',
  registrationDate: 'Meldedatum',
  pleseSelectShortCut: 'Bitte eine Woche wählen',
  printOrder: 'Andrucken',
  report: {
    pigletInstruction: {
      title: 'Ferkeltransportliste',
      create: 'Ferkeltransportliste erstellen'
    }
  },
  context: {
    piglet: 'Ferkel',
    babyPiglet: 'Babyferkel'
  },
  registrationType: {
    registration: 'Meldung',
    order: 'Bestellung'
  },
  notification: {
    save: {
      type: 'success',
      message: 'Meldegruppe erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    pigletRegister: {
      type: 'success',
      message: 'Meldung erfolgreich registriert',
      title: 'Erfolgreich gespeichert'
    },
    capacity: {
      type: 'success',
      message: 'Kapazitäten erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    register: {
      type: 'success',
      message: 'Meldung erfolgreich registriert',
      title: 'Erfolgreich gemeldet'
    },
    savePigletTransport: {
      type: 'success',
      message: 'Ferkeleinteilung erfolgreich registriert',
      title: 'Erfolgreich gemeldet'
    }
  }
}
